import React from 'react';
import { Section } from './ui/Section';
import { MinusCircle, RefreshCw, Activity } from 'lucide-react';
export function MechanismSection() {
  const cards = [{
    title: 'Reducir',
    text: 'Bajas los disparadores comunes de hinchazón (sin dogmas).',
    icon: MinusCircle
  }, {
    title: 'Restaurar',
    text: 'Hidratación + fibra inteligente + opciones más tolerables.',
    icon: RefreshCw
  }, {
    title: 'Regular',
    text: 'Evitas picos de hambre/antojos que te devuelven a lo que te inflama.',
    icon: Activity
  }];
  return <Section background="cream" data-id="element-77">
      <div className="text-center mb-8 md:mb-12" data-id="element-78">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-79">
          Sistema 3R (por qué esto sí encaja)
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-80">
        {cards.map((card, index) => <div key={index} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-[#E8E2DA] hover:shadow-md transition-shadow duration-300" data-id="element-81">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-[#F0F4EE] rounded-full flex items-center justify-center mb-4 md:mb-6 text-[#5B7C5B]" data-id="element-82">
              <card.icon className="h-6 w-6" data-id="element-83" />
            </div>
            <h3 className="text-xl font-serif font-bold text-[#2D2A26] mb-3" data-id="element-84">
              {card.title}
            </h3>
            <p className="text-[#6B6560]" data-id="element-85">{card.text}</p>
          </div>)}
      </div>
    </Section>;
}